import React, { useState, useEffect, useMemo, useRef } from "react";
import { FiFilter } from "react-icons/fi";
import Badge from "../../../../../components/badge/badge";
import { getApiInstance } from "../../../../../utils/api";
import { RiDraftLine } from "react-icons/ri";
import Button from "../../../../../components/button/button";
import { BiExport } from "react-icons/bi";
import Table from "../../../../../components/table/table";
import Notification from "../../../../../components/notification/notification";
import InputSearch from "../../../../../components/inputs/inputSearch/inputSearch";
import Modal from "../../../../../components/modal/modal";
import Accordion from "../../../../../components/accordion/accordion";
import Tag from "../../../../../components/tag/tag";
import "./listaMuebles.scss";
import TableEditable from "../../../../../components/tableEditable/tableEditable";
import ImageRenderer from "../../../../../components/ImageRender/ImageRender";
import { searchByKeywords } from "../../../../../utils/searchUtils";


const estadoLabels = {
    Publicado: "Publicado",
    Borrador: "Borrador",
    Archivado: "Archivado",
    PendienteDeAprobacion: "Pendiente de Aprobación",
};

const estados = [
    "Publicado",
    "Borrador",
    "Archivado",
    "Pendiente de Aprobación",
    "Sin estado",
];

const estadoDefault = "Sin estado";

const familiaMapping = {
    1: "Mobiliario Central",
    2: "Mobiliario Perimetral",
    3: "Mesas",
    4: "Probadores",
    5: "Caja",
    6: "Dotación",
    7: "Instalaciones",
    8: "Señalética",
    9: "BOH",
};

const categoriasMapping = {
    TiendasTop: "Tiendas Top",
    TiendasLight: "Tiendas Light",
    TiendasLow: "Tiendas Low",
    General: "General",
    Banner: "Banners",
    Senalizacon: "Señalización",
    PositiveStore: "Positive Store",
    MakeUp: "Make Up 400",
    Munich: "Munich",
    Copenhague: "Copenhague",
};

const columns = [
    {
        key: "rutaImagen",
        label: "Miniatura",
        render: (row) => (
            <ImageRenderer
                thumbnail={row.rutaImagen}
                alt={row.nombreBook || "Sin nombre"}
            />
        ),
    },
    { key: "nombreBook", label: "Nombre", className: "col-nombre" },
    { key: "referencia", label: "Referencia" },
    {
        key: "variante",
        label: "Variante",
        render: (row) => row.variante || "N/A",
    },
    {
        key: "nombreFamilia",
        label: "Categoría",
        render: (row) => familiaMapping[row.codFamilia] || "N/A",
    },
    {
        key: "categorias",
        label: "Imagen",
        render: (row) => {
            if (Array.isArray(row.categorias) && row.categorias.length > 0) {
                return row.categorias
                    .map(
                        (categoria) => categoriasMapping[categoria] || categoria
                    )
                    .join(", ");
            } else {
                return "Sin categorías";
            }
        },
    },
    { key: "medida", label: "Unidad de medida" },
    {
        key: "estado",
        label: "Estado",
        render: (row) => {
            let variant = "default";
            let estadoLegible = estadoLabels[row.estado] || "Sin estado";

            if (row.estadoModificacion === 3) {
                estadoLegible = "Descatalogado";
                variant = "danger";
            } else if (row.estadoModificacion === 4) {
                estadoLegible = "Nuevo";
                variant = "success";
            } else if (row.estadoModificacion === 2) {
                estadoLegible = "Modificado";
                variant = "success";
            } else {
                switch (row.estado) {
                    case "Publicado":
                        variant = "success";
                        break;
                    case "Borrador":
                        variant = "warning";
                        break;
                    case "Archivado":
                        variant = "info";
                        break;
                    case "PendienteDeAprobacion":
                        variant = "info";
                        break;
                    case "EnEdicion":
                        variant = "success";
                        break;
                    case "ListoParaPublicar":
                        variant = "success";
                        break;
                    default:
                        variant = "default";
                }
            }

            return <Badge label={estadoLegible} variant={variant} />;
        },
    },
];

export default function ListaMuebles() {
    const [products, setProducts] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedMuebles, setSelectedMuebles] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [filterVariantes, setFilterVariantes] = useState([]);
    const [filterCategoria, setFilterCategorias] = useState([]);
    const [filterSubcategoria, setFilterSubcategoria] = useState([]);
    const [filterEstado, setFilterEstado] = useState([]);
    const [filterFamilia, setFilterFamilia] = useState([]);
    const [variantes, setVariantes] = useState([]);
    const [subCategorias, setSubcategorias] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [familias, setFamilias] = useState([]);
    const notificationRef = useRef();
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);


    const api = getApiInstance();

    const fetchProducts = async () => {
        try {
            const response = await api.get("/api/Mueble/GetAllMuebles");
            setProducts(response.data || []);

            console.log("aklsdjlaksdj", response.data);
        } catch (error) {
            notificationRef.current.addNotification(
                "Error al obtener los muebles.",
                "error"
            );
            setProducts([]);
        }
    };

    useEffect(() => {
        fetchProducts();
    }, []);

    useEffect(() => {
	setFilteredProducts(products);
}, [products]);


    useEffect(() => {
        const allVariantes = products
            .map((product) => product.variante) // Extraer variantes de cada producto
            .flat() // Aplanar el array (porque variantes es un array dentro de cada producto)
            .filter((value, index, self) => self.indexOf(value) === index); // Filtrar duplicados

        // Filtrar subcategorías sin duplicados
        const allSubcategorias = products
            .map((product) => product.categorias)
            .flat()
            .filter((value, index, self) => self.indexOf(value) === index);

        // Filtrar categorías sin duplicados
        const allCategorias = products
            .map((product) => familiaMapping[product.codFamilia])
            .filter((value, index, self) => self.indexOf(value) === index);

        const allFamilias = products
            .map((product) => product.nombreFamilia)
            .filter(
                (value, index, self) =>
                    self.indexOf(value) === index && value != null
            );

        // Actualizar el estado
        setVariantes(allVariantes);
        setSubcategorias(allSubcategorias);
        setCategorias(allCategorias);
        setFamilias(allFamilias);
    }, [products]);

    const handleEnviarABorradores = async () => {
        if (selectedMuebles.length === 0) {
            notificationRef.current.addNotification(
                "Selecciona al menos un mueble para enviar a Borrador.",
                "warning"
            );
            return;
        }

        try {
            const promises = selectedMuebles.map((muebleId) =>
                api.patch(`/api/Mueble/EnviarABorradores/${muebleId}`)
            );
            await Promise.all(promises);

            notificationRef.current.addNotification(
                "Todos los muebles seleccionados fueron enviados a borradores exitosamente.",
                "success"
            );
            await fetchProducts();
        } catch (error) {
            notificationRef.current.addNotification(
                "Hubo un error al intentar enviar los muebles a borradores.",
                "error"
            );
        }
    };

    const handleEnviarMuebleABorrador = async (muebleId, referencia) => {
        try {
            const response = await api.patch(
                `/api/Mueble/EnviarABorradores/${muebleId}`
            );

            if (response.status === 200) {
                notificationRef.current.addNotification(
                    `El mueble con referencia ${referencia} ha sido movido a borrador.`,
                    "success"
                );
                await fetchProducts();
            } else {
                notificationRef.current.addNotification(
                    "Hubo un problema al mover el mueble a borrador.",
                    "error"
                );
            }
        } catch (error) {
            notificationRef.current.addNotification(
                "Error al mover el mueble a borrador.",
                "error"
            );
        }
    };

    const actionsListaMuebles = (row) => [
        {
            label: "Enviar a borrador",
            onClick: () =>
                handleEnviarMuebleABorrador(row.codMueble, row.referencia),
            icon: <RiDraftLine />,
        },
    ];

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const handleAcceptFilters = () => {
        closeModal();
        setCurrentPage(1); // Resetear a página 1 cuando se apliquen filtros
    };

    const handleCleanFilter = () => {
        setFilterVariantes([]);
        setFilterCategorias([]);
        setFilterSubcategoria([]);
        setFilterEstado([]);
        setFilterFamilia([]);
        setCurrentPage(1); // Resetear a página 1 cuando se limpien filtros
    };

    const handleSelectVariante = (varianteName) => {
        setFilterVariantes((prevSelected) => {
            // Verificar si la variante ya está en la lista
            if (prevSelected.includes(varianteName)) {
                // Si ya está en la lista, eliminarla
                return prevSelected.filter(
                    (variante) => variante !== varianteName
                );
            } else {
                // Si no está, agregarla
                return [...prevSelected, varianteName];
            }
        });
    };

    const handleSelectCategoria = (categoriaName) => {
        setFilterCategorias((prevSelected) => {
            // Verificar si la categoria ya está en la lista
            if (prevSelected.includes(categoriaName)) {
                // Si ya está en la lista, eliminarla
                return prevSelected.filter(
                    (categoria) => categoria !== categoriaName
                );
            } else {
                // Si no está, agregarla
                return [...prevSelected, categoriaName];
            }
        });
    };

    const handleSelectSubcategoria = (subcategoriaName) => {
        setFilterSubcategoria((prevSelected) => {
            // Verificar si la subcategoria ya está en la lista
            if (prevSelected.includes(subcategoriaName)) {
                // Si ya está en la lista, eliminarla
                return prevSelected.filter(
                    (subcategoria) => subcategoria !== subcategoriaName
                );
            } else {
                // Si no está, agregarla
                return [...prevSelected, subcategoriaName];
            }
        });
    };

    const handleSelectFamilia = (familiaName) => {
        setFilterFamilia((prevSelected) => {
            // Verificar si la familia ya está en la lista
            if (prevSelected.includes(familiaName)) {
                // Si ya está en la lista, eliminarla
                return prevSelected.filter(
                    (familia) => familia !== familiaName
                );
            } else {
                // Si no está, agregarla
                return [...prevSelected, familiaName];
            }
        });
    };

    const handleSelectEstado = (estadoName) => {
        setFilterEstado((prevSelected) => {
            // Verificar si el estado ya está en la lista
            if (prevSelected.includes(estadoName)) {
                // Si ya está en la lista, eliminarla
                return prevSelected.filter((estado) => estado !== estadoName);
            } else {
                // Si no está, agregarla
                return [...prevSelected, estadoName];
            }
        });
    };

    const normalizeToIds = (items) => {
        if (!Array.isArray(items)) return [];
        return items
            .map((it) => {
                if (it == null) return null;
                // Si ya es un ID primitivo (string/number) devuélvelo
                if (typeof it === "string" || typeof it === "number") return it;
                // Si es un objeto, intentar extraer el id conocido
                return it.codMueble ?? it.id ?? it.cod ?? null;
            })
            .filter((v) => v !== null && v !== undefined);
    };

    const handleRowSelect = (selectedRows) => {
        // Normalizar la selección a un array de IDs antes de guardarlo en el estado
        const ids = normalizeToIds(selectedRows);
        setSelectedMuebles(ids);
    };

    const handleDownloadPlanosYExcelZip = async () => {
        if (!Array.isArray(selectedMuebles) || selectedMuebles.length === 0) {
            notificationRef.current.addNotification(
                "Selecciona al menos un mueble para descargar planos y Excel.",
                "warning"
            );
            return;
        }

        try {
            // Asegurarse de enviar sólo IDs al API
            const idsToSend = normalizeToIds(selectedMuebles);

            const response = await api.post(
                "/api/Mueble/DownloadPlanosYExcelZip",
                idsToSend,
                {
                    responseType: "blob",
                }
            );

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "PlanosYExcelMuebles.zip");
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            notificationRef.current.addNotification(
                "Error al descargar los planos y el Excel.",
                "error"
            );
            console.error("Error al descargar los planos y el Excel:", error);
        }
    };

const handleSearch = (query) => {
	setSearchTerm(query);

	if (!query.trim()) {
		setFilteredProducts(products);
		setCurrentPage(1); // Solo resetear en búsquedas
		return;
	}

	const resultados = searchByKeywords(products, query, [
		"referencia",
		"nombreBook",
		"nombreFamilia",
		"descripcion",
		"variante"
	]);

	setFilteredProducts(resultados);
	setCurrentPage(1); // Resetear a página 1 cuando se haga una nueva búsqueda
};

const visibleMuebles = useMemo(() => {
	return filteredProducts
		.filter((product) =>
			filterVariantes.length === 0 ||
			filterVariantes.includes(product.variante)
		)
		.filter((product) =>
			filterCategoria.length === 0 ||
			filterCategoria.includes(familiaMapping[product.codFamilia])
		)
		.filter((product) =>
			filterSubcategoria.length === 0 ||
			(Array.isArray(product.categorias) &&
				product.categorias.some((categoria) =>
					filterSubcategoria.includes(categoria)
				))
		)
		.filter((product) => {
			// 👉 Evaluamos correctamente "Pendiente de Aprobación"
			let estadoActual;
			if (product.isPending) {
				estadoActual = "Pendiente de Aprobación";
			} else if (estados.includes(product.estado)) {
				estadoActual = product.estado;
			} else {
				estadoActual = estadoDefault;
			}

			return (
				filterEstado.length === 0 ||
				filterEstado.includes(estadoActual)
			);
		})
		.filter((product) =>
			filterFamilia.length === 0 ||
			filterFamilia.includes(product.nombreFamilia)
		);
}, [
	filteredProducts,
	filterVariantes,
	filterCategoria,
	filterSubcategoria,
	filterEstado,
	filterFamilia
]);


    return (
        <>
            <div className="dashboard-productos__content__table-header">
                <InputSearch
                    context="tableSearch"
                    placeholder="Buscar..."
                    onSearch={handleSearch}
                />

                <div className="dashboard-productos__content__table-header__buttons">
                    <Button
                        onClick={openModal}
                        label="Filtros"
                        icon={<FiFilter />}
                    />
                    <Button
                        label="Exportar"
                        variant="outline"
                        icon={<BiExport />}
                        onClick={handleDownloadPlanosYExcelZip}
                        disabled={selectedMuebles.length === 0}
                    />
                    <Button
                        label="Enviar a borradores"
                        variant="filled"
                        onClick={handleEnviarABorradores}
                    />
                </div>
            </div>

            <Table
                data={visibleMuebles}
                columns={columns}
                actions={actionsListaMuebles}
                selectedItems={selectedMuebles}
                onRowSelect={handleRowSelect}
                currentPage={currentPage}
                onPageChange={setCurrentPage}
                resetPaginationOnDataChange={false}
            />

            <Notification ref={notificationRef} />

            <Modal
                title="Filtros"
                isOpen={isModalOpen}
                onClose={closeModal}
                onAccept={handleAcceptFilters}
                outlineButtonLabel="Limpiar"
                primaryButtonLabel={`Ver resultados (${visibleMuebles.length})`}
                onCancel={handleCleanFilter}
            >
                <div className="section-header__modal__section">
                    <Accordion title="Variante">
                        <ul className="section-header__modal__section__content">
                            {variantes.map((familia, index) => (
                                <Tag
                                    key={index}
                                    label={familia}
                                    isSelected={filterVariantes.includes(
                                        familia
                                    )}
                                    onSelect={handleSelectVariante}
                                />
                            ))}
                        </ul>
                    </Accordion>
                </div>
                <div className="section-header__modal__section">
                    <Accordion title="Categoría">
                        <ul className="section-header__modal__section__content">
                            {categorias.map((categoria, index) => (
                                <Tag
                                    key={index}
                                    label={categoria}
                                    isSelected={filterCategoria.includes(
                                        categoria
                                    )}
                                    onSelect={handleSelectCategoria}
                                />
                            ))}
                        </ul>
                    </Accordion>
                </div>
                <div className="section-header__modal__section">
                    <Accordion title="Imagen">
                        <ul className="section-header__modal__section__content">
                            {subCategorias.map((subcategoria, index) => (
                                <Tag
                                    key={index}
                                    label={subcategoria}
                                    isSelected={filterSubcategoria.includes(
                                        subcategoria
                                    )}
                                    onSelect={handleSelectSubcategoria}
                                />
                            ))}
                        </ul>
                    </Accordion>
                </div>
                <div className="section-header__modal__section">
                    <Accordion title="Estado">
                        <ul className="section-header__modal__section__content">
                            {estados.map((estado, index) => (
                                <Tag
                                    key={index}
                                    label={estado}
                                    isSelected={filterEstado.includes(estado)}
                                    onSelect={handleSelectEstado}
                                />
                            ))}
                        </ul>
                    </Accordion>
                </div>
            </Modal>
        </>
    );
}
